import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js'
import "./navbar.css"
import { GiHamburgerMenu } from "react-icons/gi"



export const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg sticky-top navbar-custom">
        <div className="container">
          <a className="navbar-brand text-black" href="/">Faiz</a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <GiHamburgerMenu/>
          </button>
          <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
            <ul className="navbar-nav">
              <li className="nav-item">
                <a className="nav-link text-black" aria-current="page" href="/">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link text-black" href="#projects">Projects</a>
              </li>
              <li className="nav-item">
                <a className="nav-link text-black" href="#about-me">About Me</a>
              </li>
              <li className="nav-item">
                <a className="nav-link text-black" href="#contact">Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
  )
}